<template>
  <div :class="['rb-sorter', { 'rb-active': active }]">
    <div class="rb-sorter-buttons flex direction-column align-items-center">
      <button
        v-if="!active || (active && sortMode === 'asc')"
        @click.prevent="toggleMode"
        :aria-label="'Sort ' + label + 'up'"
      >
        <icon-arrow-up />
      </button>
      <button
        v-if="!active || (active && sortMode === 'desc')"
        @click.prevent="toggleMode"
        :aria-label="'Sort ' + label + 'down'"
      >
        <icon-arrow-down />
      </button>
    </div>
  </div>
</template>
<script>
/**
 * Sort header with arrows
 *
 * @props
 * type: String
 * label: String
 * mode: String
 *
 * @implements
 * CommMixin
 *
 * @emits
 * rb-sort
 *
 * @listens
 * rb-sorted
 */
import CommMixin from "@/mixins/CommMixin";
import IconArrowUp from "@/components/icons/IconArrowUp";
import IconArrowDown from "@/components/icons/IconArrowDown";
export default {
  mixins: [CommMixin],
  components: { IconArrowUp, IconArrowDown },
  props: {
    type: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      sortMode: "asc",
      active: false,
    };
  },
  mounted: function () {
    this.sortMode = this.mode;
    this.initEvents();
  },
  watch: {
    mode: function () {
      this.sortMode = this.mode;
    },
  },
  methods: {
    initEvents: function () {
      this.subscribe("rb-sorted", this.onSorted);
    },
    onSorted: function (sortMode) {
      if (sortMode.type === this.type) {
        this.active = true;
        this.sortMode = sortMode.mode;
      } else {
        this.active = false;
      }
    },
    toggleMode: function () {
      this.sortMode = this.sortMode === "asc" ? "desc" : "asc";
      this.broadcast("rb-sort", { type: this.type, mode: this.sortMode });
    },
  },
};
</script>
